import { render, staticRenderFns } from "./dragdrop-tooltip-container.vue?vue&type=template&id=20fbeb51"
import script from "./dragdrop-tooltip-container.vue?vue&type=script&lang=js"
export * from "./dragdrop-tooltip-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports